@if (show()) {
  <bit-callout
    class="[&_aside]:!tw-m-0"
    type="info"
    icon="bwi-rocket"
    [title]="'whatsNew' | i18n"
    (dismiss)="dismiss()"
  >
    {{ "tourTheNewVaultDescription" | i18n }}
    <button
      slot="end"
      type="button"
      bitButton
      buttonType="primary"
      endIcon="bwi-arrow-right"
      (click)="startTour()"
    >
      {{ "exploreTheNewVault" | i18n }}
    </button>
  </bit-callout>
}
